/****************************************************
 * Module Name:  processProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ProcessProxy {

  static GetAllProcess = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/process",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleProcess = (processId, callback) => {
    let params = {
      id: processId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/process",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckProcessAvailable = (process, callback) => {
    let params = {
      process: process,
    };

    restAPICall(
      Constants.MANAGER_URL + "/process/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddProcess = (process, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/process",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(process),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateProcess = (process, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/process",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(process),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteProcess = (process, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/process",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(process),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllProcessBySequence = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/process/byseq",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}
